import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator, Functions } from 'firebase/functions';

// Validate required environment variables
const requiredEnvVars = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN', 
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET',
  'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  'REACT_APP_FIREBASE_APP_ID'
];

for (const envVar of requiredEnvVars) {
  if (!process.env[envVar]) {
    throw new Error(`Missing required environment variable: ${envVar}`);
  }
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY!,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN!,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID!,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET!,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID!,
  appId: process.env.REACT_APP_FIREBASE_APP_ID!
};
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Offline tároló (PWA): a már betöltött adatok net nélkül is olvashatók, az írások sorba állnak és
// visszatérő kapcsolatnál szinkronizálódnak – több fül között is.
let _db;
try {
  _db = initializeFirestore(app, { localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }) });
} catch (e) {
  console.warn('[firestore] offline cache nem elérhető, memória mód', e);
  _db = getFirestore(app);
}
export const db = _db;
export const storage = getStorage(app);

// Create a completely fresh Functions instance with error handling
let functions: Functions;
try {
  functions = getFunctions(app, 'us-central1');
} catch (error) {
  console.error('Error initializing Firebase Functions:', error);
  // Fallback: try without region
  functions = getFunctions(app);
}
export { functions };

// Functions emulátor: csak kifejezett kérésre (REACT_APP_USE_FUNCTIONS_EMULATOR=true a .env.development.local-ban).
// Korábban minden fejlesztői futás a localhost:5001-re ment, és ha nem futott emulátor,
// minden callable 'internal' hibával elhalt.
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true') {
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
    console.info('[firebase] Functions emulator: localhost:5001');
  } catch (error) {
    // Emulator not available, using production
  }
}